/**
 * This file should contain color codes used for Future Skill
 */

/** Primary dark blue #295C88, used for buttons and headers */
export const fsDarkBlue = '#295C88';

export const fsDarkBlueHoverDark = '#1d4161';

/** Primary light blue #EDF3F7, used for light backgrounds and highlights*/
export const fsLightBlue = '#EDF3F7';

/** Primary cyan #00B8B8 (green), used for buttons and headers */
export const fsCyan = '#00B8B8';

/** Dark mode editor background */
export const monokaiBackground = '#272822';
export const monokaiBackgroundOffset = '#2F3129';
export const monokaiCommentColor = '#ababab';

/** Page background in dark mode */
export const darkModeBackground = '#151515';

/** check and radio button selected color for use in light mode */
export const checkmark = '#2196f3';

/**
 * Color comments for displaying the color value when inserting a color
 */
export const colors = {
  /** #ffffff */
  white: '#ffffff',
  /** rgba(255, 255, 255, 0.5 */
  whiteTransparent: 'rgba(255, 255, 255, 0.5)',
  /** #000000 */
  black: '#000000',
  /** fsLightBlue */
  fsLightBlue,
  /** fsDarkBlue */
  fsDarkBlue,
  /**fsDarkBlueHoverDark */
  fsDarkBlueHoverDark,
  /** fsCyan */
  fsCyan,
  /** checkmark */
  checkmark,
  /** #BEBEC1 */
  gray: '#BEBEC1',
  /** #a1a1a1 */
  gray2: '#a1a1a1',
  /** #dee2e6 */
  gray3: '#dee2e6',
  /** #e5e5e5 */
  gray4: '#e5e5e5',
  /** c9d4e1 */
  gray5: '#c9d4e1',
  /** #efefef */
  lightGray: '#efefef',
  /** #999999 */
  lightGray1: '#999999',
  /** #888888 */
  lightGray2: '#888888',
  /** #555555 */
  darkGray: '#555555',
  /** #222222 */
  darkGray2: '#222222',
  /** #151515 darkModeBackground */
  darkGray3: darkModeBackground,
  /** 4d5265 */
  darkGray4: '#4d5265',
  /** #dee2e6 */
  borderGray: '#dee2e6',
  /** #EDF3F7 fsLightBlue */
  lightBlue: fsLightBlue,
  /** #295c88 fsDarkBlue */
  darkBlue: fsDarkBlue,
  /** #373a3c */
  darkBlue2: '#373a3c',
  /** #448ac7 */
  hoverBlue: '#448ac7',
  /** #ba2a2f */
  darkRed: '#ba2a2f',
  /** #c65853 */
  red: '#c65853',
  /** #00b8b8 fsCyan */
  green: fsCyan,
  /** #7ec666 */
  green2: '#7ec666',
  /** #addb9e */
  hoverGreen: '#addb9e',
  /** #f0c700 */
  gold: '#f0c700',
  /** #707070 */
  silver: '#707070',
  /** #d68100 */
  bronze: '#d68100',
  /** #36e0b7 */
  lightGreen: '#36e0b7',
  /** #fdbd4c */
  yellow: '#fdbd4c',
  /** #e4edf3 */
  lightBlue2: '#e4edf3',
  /** #d9edf7 */
  lightBlue3: '#d9edf7',
  /** #31708f */
  lightBlue4: '#31708f',
  /** #bcdff1 */
  lightBlue5: '#bcdff1',
  /** #7f9bb3 */
  lightBlue6: '#7f9bb3',
  /** #F5F7FA */
  fsLightBlueHover: '#F5F7FA',
  /** #fcf8e3 */
  lightYellow: '#fcf8e3',
  /** #faf2cc */
  lightYellow2: '#faf2cc',
  /** #8a6d3b */
  lightBrown: '#8a6d3b',
  /** #f2dede */
  lightRed: '#f2dede',
  /** #ebcccc */
  lightRed2: '#ebcccc',
  /** #a94442 */
  lightRed3: '#a94442',
  /** #EF4423 */
  lightRed4: '#EF4423',
  /** #ff000075 */
  lightRed5: '#ff000075',
};
